"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearForms = exports.updateForms = exports.deleteForm = exports.setFieldProperty = exports.fileUpload = exports.isFileNameValid = exports.resetFiles = exports.removeFile = exports.submitForm = exports.submitFormError = exports.submitFormComplete = exports.submitFormPending = exports.setFieldValidation = exports.setFormValidation = exports.displayFormErrors = exports.handleFieldChange = exports.removeForm = exports.resetForm = exports.initForm = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("egov-ui-kit/redux/app/actions");

var _actions2 = require("egov-ui-kit/redux/auth/actions");

var _api = require("egov-ui-kit/utils/api");

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _utils = require("./utils");

var _transformers = require("config/forms/transformers");

var _transformers2 = _interopRequireDefault(_transformers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initForm = exports.initForm = function initForm(form, recordData) {
  return {
    type: actionTypes.INIT_FORM,
    form: form,
    recordData: recordData
  };
};

var resetForm = exports.resetForm = function resetForm(formKey) {
  return { type: actionTypes.RESET_FORM, formKey: formKey };
};

var removeForm = exports.removeForm = function removeForm(formKey) {
  return { type: actionTypes.REMOVE_FORM, formKey: formKey };
};

var handleFieldChange = exports.handleFieldChange = function handleFieldChange(formKey, fieldKey, value) {
  return {
    type: actionTypes.FIELD_CHANGE,
    formKey: formKey,
    fieldKey: fieldKey,
    value: value
  };
};

var displayFormErrors = exports.displayFormErrors = function displayFormErrors(formKey) {
  return { type: actionTypes.DISPLAY_FORM_ERRORS, formKey: formKey };
};

var setFormValidation = exports.setFormValidation = function setFormValidation(formKey, isFormValid) {
  return { type: actionTypes.VALIDATE_FORM, isFormValid: isFormValid, formKey: formKey };
};

var setFieldValidation = exports.setFieldValidation = function setFieldValidation(formKey, fieldKey, errorText) {
  return { type: actionTypes.VALIDATE_FIELD, formKey: formKey, fieldKey: fieldKey, errorText: errorText };
};

var submitFormPending = exports.submitFormPending = function submitFormPending(formKey) {
  return { type: actionTypes.SUBMIT_FORM_PENDING, formKey: formKey };
};

var submitFormComplete = exports.submitFormComplete = function submitFormComplete(formKey, payload, saveUrl) {
  return { type: actionTypes.SUBMIT_FORM_COMPLETE, formKey: formKey, payload: payload };
};

var submitFormError = exports.submitFormError = function submitFormError(formKey, error) {
  return { type: actionTypes.SUBMIT_FORM_ERROR, formKey: formKey, error: error };
};

var submitForm = exports.submitForm = function submitForm(formKey, saveUrl) {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, form, isFormValid, action, formData, formResponse, message, re;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              form = state.form[formKey];

              if (!form.loading) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              isFormValid = (0, _utils.validateForm)(form);

              if (!(isFormValid === true && saveUrl === "/rainmaker-pgr/v1/requests/_create")) {
                _context.next = 9;
                break;
              }

              if (!(form.fields && form.fields.location && form.fields.location.value === 'null,null')) {
                _context.next = 9;
                break;
              }

              dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: "Location Can'not be null", labelKey: "COMM_SERVICE_LOCATION_NULL_VALIDATION_MESSAGE" }, "warning"));
              return _context.abrupt("return");

            case 9:
              if (!isFormValid) {
                _context.next = 43;
                break;
              }

              dispatch(submitFormPending(formKey));
              action = form.action;
              _context.prev = 12;
              _context.next = 15;
              return (0, _transformers2.default)("viewModelToBusinessModelTransformer", formKey, form, state);

            case 15:
              formData = _context.sent;
              formResponse = {};
              // this will eventually moved out to the auth action; bit messy

              if (!formData.hasOwnProperty("login")) {
                _context.next = 23;
                break;
              }

              _context.next = 20;
              return (0, _api.loginRequest)(formData.login.username, formData.login.password, "", "password", "", "CITIZEN");

            case 20:
              formResponse = _context.sent;
              _context.next = 32;
              break;

            case 23:
              if (!formData.hasOwnProperty("employee")) {
                _context.next = 29;
                break;
              }

              _context.next = 26;
              return (0, _api.loginRequest)(formData.employee.username, formData.employee.password, "", "password", formData.employee.tenantId, "EMPLOYEE");

            case 26:
              formResponse = _context.sent;
              _context.next = 32;
              break;

            case 29:
              _context.next = 31;
              return (0, _api.httpRequest)(saveUrl, action, [], formData);

            case 31:
              formResponse = _context.sent;

            case 32:
              dispatch(submitFormComplete(formKey, formResponse, saveUrl));
              if (saveUrl === '/user/password/_update') {
                dispatch((0, _actions2.logout)());
              }
              _context.next = 41;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](12);
              message = _context.t0.message;
              // throw new Error(error);

              dispatch(submitFormError(formKey, message));
              dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: message, labelKey: message }, "error"));

            case 41:
              _context.next = 45;
              break;

            case 43:
              dispatch(displayFormErrors(formKey));
              if (formKey === 'complaintResolved' || formKey === 'rejectComplaint' || formKey === 'reopenComplaint' || formKey === 'feedback') {
                dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: "Please mention your reason", labelKey: "CS_COMMON_COMMENT_SPECIAL_VALIDATION" }, "error"));
              } else if (form && form.fields && form.fields.textarea && form.fields.textarea.value !== undefined) {
                re = /^[^\$\"'<>?\\\\~`!@#$%^()+={}\[\]*:;“”‘’]{1,249}$/;

                if (!re.test(form.fields.textarea.value)) {
                  dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: "Please mention your reason", labelKey: "CS_COMMON_COMMENT_SPECIAL_VALIDATION" }, "error"));
                }
              }

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[12, 36]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

// file actions
var fileUploadPending = function fileUploadPending(formKey, fieldKey, fileObject) {
  return { type: actionTypes.FILE_UPLOAD_STARTED, formKey: formKey, fieldKey: fieldKey, fileObject: fileObject };
};

// for profile if a file exists, dispatch
var fileUploadCompleted = function fileUploadCompleted(formKey, fieldKey, fileStoreId, fileName) {

  (0, _actions.toggleSnackbarAndSetText)(true, { labelName: "File upload success", labelKey: "CORE_COMMON_IMAGE_FILE_UPLOAD_SUCCESS" }, "success");
  return { type: actionTypes.FILE_UPLOAD_COMPLETED, formKey: formKey, fieldKey: fieldKey, fileStoreId: fileStoreId, fileName: fileName };
};

var fileUploadError = function fileUploadError(formKey, fieldKey, error, fileName) {
  return { type: actionTypes.FILE_UPLOAD_ERROR, formKey: formKey, fieldKey: fieldKey, error: error, fileName: fileName };
};

var removeFile = exports.removeFile = function removeFile(formKey, fieldKey, fileIndex) {
  //dispatch(toggleSnackbarAndSetText(true, { labelName: "File Upload Success", "CORE_COMMON_IMAGE_FILE_REMOVE_SUCCESS": message }, "success"));


  return { type: actionTypes.FILE_REMOVE, fieldKey: fieldKey, formKey: formKey, fileIndex: fileIndex };
};

var resetFiles = exports.resetFiles = function resetFiles(formKey) {
  return { type: actionTypes.RESET_FILES, formKey: formKey };
};
var isFileNameValid = exports.isFileNameValid = function isFileNameValid(name, char) {
  var format = /^[`!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?]*$/;
  var specialChars = "<>@!#$%^&*()+[]{}?:;|'\"\\,/~`=";
  // for (let index = 0; index < array.length; index++) {
  //   const element = array[index];

  // }

  for (var i = 0; i < specialChars.length; i++) {
    if (name.indexOf(specialChars[i]) > -1) {
      return true;
    }
  }
  return false;
};
// currently supports only single file upload at a time, although the API has support for multiple file upload
// TODO : can the upload happen at a later point in time? Challenge is to intimate the user if in case of a failure
var fileUpload = exports.fileUpload = function fileUpload(formKey, fieldKey, fileObject, ulbLevel) {
  var fileName = fileObject.file.name;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var ValidFileName, fileStoreId;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fileUploadPending(formKey, fieldKey, fileObject));
              _context2.prev = 1;
              ValidFileName = false;

              ValidFileName = isFileNameValid(fileObject.file.name);

              if (!(ValidFileName === false)) {
                _context2.next = 12;
                break;
              }

              _context2.next = 7;
              return (0, _api.uploadFile)(_endPoints.FILE_UPLOAD.POST.URL, fileObject.module, fileObject.file, ulbLevel);

            case 7:
              fileStoreId = _context2.sent;

              dispatch(fileUploadCompleted(formKey, fieldKey, fileStoreId, fileName));
              dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: "File upload success", labelKey: "CORE_COMMON_IMAGE_FILE_UPLOAD_SUCCESS" }, "success"));
              _context2.next = 14;
              break;

            case 12:
              //   let labelName = "Upload file name not include any special char"
              //  let labelKey = "CORE_COMMON_INVALID_FILE_NAME"
              //   store.dispatch(toggleSnackbar(true, { labelName:labelName,labelKey:labelKey}, "warning"));
              dispatch(fileUploadError(formKey, fieldKey, "Upload file name not include any special char", fileName));
              dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: "CORE_COMMON_INVALID_FILE_NAME", labelKey: "CORE_COMMON_INVALID_FILE_NAME" }, "warning"));

            case 14:
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](1);

              dispatch(fileUploadError(formKey, fieldKey, _context2.t0.message, fileName));
              dispatch((0, _actions.toggleSnackbarAndSetText)(true, { labelName: _context2.t0.message, labelKey: _context2.t0.message }, "error"));

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[1, 16]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var setFieldProperty = exports.setFieldProperty = function setFieldProperty(formKey, fieldKey, propertyName, propertyValue) {
  return { type: actionTypes.SET_FIELD_PROPERTY, formKey: formKey, fieldKey: fieldKey, propertyName: propertyName, propertyValue: propertyValue };
};

var deleteForm = exports.deleteForm = function deleteForm(formKey) {
  return {
    type: actionTypes.DELETE_FORM,
    formKey: formKey
  };
};

var updateForms = exports.updateForms = function updateForms(forms) {
  return {
    type: actionTypes.UPDATE_FORM,
    forms: forms
  };
};

var clearForms = exports.clearForms = function clearForms() {
  return {
    type: actionTypes.CLEAR_FORMS
  };
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/form/actions.js
// module id = 46
// module chunks = 895